import { Flex, Heading, Text } from "@chakra-ui/react"

const Forbidden = () => {
  return (
    <Flex direction="column" justify="center" align="center" minH="90vh">
      <Heading as="h1" size="4xl" color="gray.600">
        403
      </Heading>
      <Text mt="2" fontSize="xl" fontWeight="medium" color="gray.500">
        Forbidden
      </Text>
    </Flex>
  )
}

export default Forbidden
